module.exports = __webpack_public_path__ + "static/RevitIcon-17d5231ff41390e3eeed293d6c9b1f41.jpg";